import { fromNode } from '@rehaje/core'
import { reactive } from '@rehaje/reactive'

import { ValuableModel } from '../../models/ValuableModel'

export class SchemaBigIntModel extends ValuableModel {
  @fromNode()
  @reactive()
  maximum?: bigint | number

  @fromNode()
  @reactive()
  minimum?: bigint | number
}

declare global {
  export interface RehajeViewModels {
    'Schema.BigInt': SchemaBigIntModel
  }
}
